import { Box, Button, Heading, Text } from '@chakra-ui/react'
import React from 'react'

function ToggleCard({cost,currency,symbol}) {
    

    if(cost!==false){
        return (
            <>
               <Text mb="2">Starts at<br/><Box display="flex">{symbol}<Heading>{cost}</Heading>*</Box>/month*</Text>
               <Button colorScheme='teal' borderRadius="none" p="0rem 35%" size="lg" >Buy Now</Button> 
            </>
          )
    }else{
        return (
            <>
                <Text  m="1rem 0rem 3rem 0rem">You've selected more contacts than this plan allows</Text>
                <Text md="2rem" bgColor="#dbd9d2" textAlign="center" color="black" p=".75rem 2rem">Contact limit exceeded</Text>
            </>
        )
    }
 
}

export default ToggleCard